import { Box, CircularProgress, Typography } from '@mui/material'

export default function LoadingPratiche(props) {
  const { testo } = props

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      p={3}
      sx={{
        borderRadius: 2,
        border: '2px solid #ccc',
        boxShadow: 3,
        minWidth: 300,
        minHeight: 200,
        textAlign: 'center',
      }}
    >
      <CircularProgress size={28} />
      <Typography variant='subtitle1' sx={{ mt: 2 }}>{testo}</Typography>
    </Box>
  )
}